import { useMemo } from 'react';

import theme from 'theme';

import { useWindowDimensions } from './useWindowDimensions';

export interface ScreenSizes {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
}

export const useScreenSizes = (): ScreenSizes => {
  const { width } = useWindowDimensions();

  const screenSizes = useMemo(() => {
    const breakpoints = {
      sm: parseInt(theme.breakpoints.sm.replace('px', '')),
      md: parseInt(theme.breakpoints.md.replace('px', '')),
      lg: parseInt(theme.breakpoints.lg.replace('px', '')),
      xl: parseInt(theme.breakpoints.xl.replace('px', '')),
      xxl: parseInt(theme.breakpoints.xxl.replace('px', '')),
    };

    const isMobile = width < breakpoints.sm;
    const isTablet = width >= breakpoints.sm && width < breakpoints.lg;
    const isDesktop = width >= breakpoints.lg;

    return {
      isMobile,
      isTablet,
      isDesktop,
    };
  }, [width]);

  return screenSizes;
};
